// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import TerceraDateSelectorDropDownTemplate from '@front/templates/TerceraDateSelectorDropDownTemplate.html';
import { Resources } from '@shared/localizations/Resources';
import { TerceraDateDropDownBase } from './TerceraDateDropDownBase';
import { BOTTOM_WINDOWS_MARGIN } from '../../UtilsClasses/SizeConstants';
import { ControlEvents } from '../Control';
import { FullScreenManager } from '../../UtilsClasses/FullScreenManager';
import { TimeScale } from '@components/webdesktop/elements/Numerics/TimeNumeric/TimeScale';
export class DateSelectorButton {
    constructor(text, callback, style = 'js-button-blue') {
        this.style = style;
        this.callback = callback;
        this.text = text;
    }
}
export class TerceraDateSelectorDropDown extends TerceraDateDropDownBase {
    constructor() {
        super();
        this.onHoursChanged = (context, newHours) => {
            void this.set({ hours: newHours });
        };
        this.onMinutesChanged = (context, newMinutes) => {
            void this.set({ minutes: newMinutes });
        };
        this.onHoursChangedReact = (value) => {
            void this.set({ hours: value !== null && value !== void 0 ? value : 0 });
        };
        this.onMinutesChangedReact = (value) => {
            void this.set({ minutes: value !== null && value !== void 0 ? value : 0 });
        };
    }
    getType() {
        return 'TerceraDateSelectorDropDown';
    }
    oncomplete() {
        super.oncomplete();
        this.on('dateBtnClick', () => {
            void this.set({ ShowDate: true });
        });
        this.on('timeBtnClick', () => {
            void this.set({ ShowDate: false });
        });
        this.on('buttonClick', this.buttonClick);
        this.on('onHoursChanged', this.onHoursChanged);
        this.on('onMinutesChanged', this.onMinutesChanged);
        this.setFocus();
        const picker = this.Controls.dtPicker.picker;
        picker.update('maxDate', '');
        picker.update('minDate', new Date());
        this.localize();
        this.observe('date', (newValue) => {
            if (newValue) {
                this.Controls.dtPicker.picker.selectDate(newValue);
                const h = newValue.getHours();
                const m = newValue.getMinutes();
                void this.set({ hours: h, minutes: m, selectDate: newValue });
            }
        });
        picker.update('onRenderCell', this.datePickerOnRenderCell.bind(this));
        picker.update('onSelect', this.onSelectDateTo.bind(this));
        // this.on(Control.Events.LostFocus, function () { this.close(); }.bind(this));
        this.on(ControlEvents.LostFocus, this.close);
        FullScreenManager.fullscreenExit.Subscribe(this.close, this);
        this.setCorrectLocation();
    }
    setMinMax(minDate, maxDate) {
        var _a, _b;
        const picker = (_b = (_a = this.Controls) === null || _a === void 0 ? void 0 : _a.dtPicker) === null || _b === void 0 ? void 0 : _b.picker;
        picker === null || picker === void 0 ? void 0 : picker.update('minDate', minDate !== null && minDate !== void 0 ? minDate : '');
        picker === null || picker === void 0 ? void 0 : picker.update('maxDate', maxDate !== null && maxDate !== void 0 ? maxDate : '');
    }
    datePickerOnRenderCell(date, cellType) {
        const nowDate = new Date();
        const selectedDate = this.get('selectDate');
        if (this.isDayInPeriodRange(date, nowDate, selectedDate)) {
            return this.getRangeClassesIfInRange(date, selectedDate, nowDate);
        }
    }
    onSelectDateTo() {
        const picker = this.Controls.dtPicker.picker;
        const pickerArr = picker.selectedDates;
        const selectDate = pickerArr.length ? pickerArr[0] : pickerArr.currentDate;
        void this.set({ selectDate });
    }
    close() {
        // Дикая херня!!!
        if (this.torndown) {
            return;
        }
        //
        super.close();
        this.fire('timeSelectorLookupClosed');
    }
    dispose() {
        FullScreenManager.fullscreenExit.UnSubscribe(this.close, this);
        super.dispose();
    }
    buttonClick(context, callback) {
        const picker = this.Controls.dtPicker.picker;
        const dateFromArr = picker.selectedDates;
        const dateFrom = dateFromArr.length ? dateFromArr[0] : picker.currentDate;
        const h = this.get('hours');
        const m = this.get('minutes');
        dateFrom.setHours(h);
        dateFrom.setMinutes(m);
        callback(dateFrom);
        this.close();
    }
    setCorrectLocation() {
        let x = this.get('left');
        let y = this.get('top');
        const container = this.find('*');
        const width = container.offsetWidth;
        const height = container.offsetHeight;
        if (x + width > window.innerWidth) {
            x = window.innerWidth - width - 2;
        }
        const margin = FullScreenManager.IsFullScreenMode ? 0 : BOTTOM_WINDOWS_MARGIN;
        if (y + height > window.innerHeight - margin) {
            y = window.innerHeight - margin - height - 2;
        }
        void this.set({ left: x, top: y });
    }
    localize() {
        void this.set({
            buttonDateText: Resources.getResource('property.IsDateVisible'),
            buttonTimeText: Resources.getResource('property.IsTimeVisible'),
            hoursLabel: Resources.getResource('timeSelector.Hours'),
            minutesLabel: Resources.getResource('timeSelector.Minutes')
        });
    }
    isDayInPeriodRange(date, nowDate, selectedDate) {
        if (nowDate < selectedDate) {
            return date >= nowDate && date <= selectedDate;
        }
        else {
            return date >= selectedDate && date <= nowDate;
        }
    }
}
TerceraDateDropDownBase.extendWith(TerceraDateSelectorDropDown, {
    data: function () {
        return {
            TimeScale,
            resizable: false,
            showHeader: false,
            showFooter: false,
            ShowDate: true,
            buttonDateText: '',
            buttonTimeText: '',
            applyBtnText: '',
            hoursLabel: '',
            minutesLabel: '',
            hours: 0,
            minutes: 0,
            style_addition_header: '',
            date: new Date(),
            selectedDate: new Date(),
            isOnlyDate: false,
            buttons: [],
            labelsForMinutesSlider: new Map([
                [15, '15'],
                [30, '30'],
                [45, '45']
            ]),
            labelsForHourSlider: new Map([
                [3, '3'],
                [6, '6'],
                [9, '9'],
                [12, '12'],
                [15, '15'],
                [18, '18'],
                [21, '21']
            ])
        };
    },
    partials: { bodyPartial: TerceraDateSelectorDropDownTemplate }
});
